export interface BlogPost {
  id: string;
  title: string;
  subtitle: string;
  date: string;
  author: {
    name: string;
    role: string;
  };
  category: "announcement" | "partnership" | "research" | "update";
  excerpt: string;
  content: string; // Markdown content
  featured: boolean;
}


export const blogPosts: BlogPost[] = [
  {
    id: "announcement-of-the-special-math-contest-2026-award-ceremony",
    title: "Announcement of the Special Math Contest: 2026 Award Ceremony",
    subtitle: "Unpatterned is proud to support the 2026 Special Math Contest (SMC), organized by the Special Math Academy.",
    date: "2026-02-28",
    author: {
      name: "Unpatterned Team",
      role: "Founders",
    },
    category: "partnership",
    excerpt: "Unpatterned is proud to support the 2026 Special Math Contest (SMC), organized by the Special Math Academy.",
    content: `
Unpatterned, a global social initiative focused on strengthening cognitive depth in an age of AI and automation, is proud to support the 2026 [Special Math Contest](https://specialmathscontest.com/) (SMC), organized by the Special Math Academy.

In a world increasingly shaped by intelligent systems and automated decision-making, Unpatterned believes that disciplined thinking, cognitive depth, structured reasoning, and intellectual endurance are more important than ever. Mathematics competitions such as SMC provide rare platforms where young people are challenged to think rigorously, solve complex problems, and develop the cognitive faculties that underpin science, technology, and institutional leadership.

## A Growing Global Platform

The 2026 Special Math Contest recorded significant growth:

| Category                | 2025  | 2026  | Growth |
|-------------------------|------:|------:|-------:|
| Total Applications      | 1,407 | 2,013 |   +70% |
| Total Participants      |     — |   954 |      — |
| Countries Represented   |    30 |    49 |   +63% |
| Foreign Applications    |     — |   472 |      — |
| Female Participants     |     — |   382 |   ~40% |

Participants represented 49 countries, including Nigeria, Rwanda, Pakistan, India, the Philippines, Tanzania, Canada, the United States, and over 30 additional nations, reflecting the contest’s expanding international reach.
Gender participation data was formally tracked for the first time in 2026, with female candidates accounting for approximately 40% of participants.



### Sponsorship Commitment

Unpatterned committed a self-funded sponsorship budget of $3,000 to increase visibility, enhance competitiveness, and extend long-term opportunities for participants.

The partnership included:
- Strategic media and digital publicity support
- Co-branded promotional efforts
- Prize sponsorship for both global and Nigerian winners

### Overall Winners
- 1st Place: $450
- 2nd Place: $300
- 3rd Place: $200

### Top Nigerian Winners
- 1st Place: ₦500,000 + Laptop
- 2nd Place: ₦250,000 + Laptop
- 3rd Place: ₦150,000 + Laptop

## Beyond the Contest

The top 20 participants will be invited to apply for the Unpatterned Labs Young Engineers & Scientists Program, which offers:
- Foundational training in software engineering, data science, and artificial intelligence
- Mentorship from global professionals
- Real-world project experience

This initiative reflects Unpatterned’s broader mission: building a global network of thoughtful individuals equipped to navigate complex technological systems responsibly.

### Award Ceremony

The 2026 award ceremony will take place:
- Date: 2nd March 2026
- Time: 10:00 AM
- Venue: Nile University of Nigeria (Niger Block), Jabi Airport Bypass, FCT-Abuja

The ceremony celebrates not only academic excellence, but the power of community support in nurturing future leaders in STEM.

As AI reshapes the nature of work and decision-making, Unpatterned remains committed to cultivating disciplined thinkers who can interpret, integrate, build, and responsibly deploy powerful technologies.
For more information, stay tuned for further announcements.`,
    featured: true,
  },
//   {
//     id: "monthly-theme-february-2026",
//     title: "February 2026 Theme: AI Safety Evaluation",
//     subtitle: "Building bias detection tools for resource-constrained contexts",
//     date: "2026-02-01",
//     author: {
//       name: "Research Team",
//       role: "Unpatterned",
//     },
//     category: "announcement",
//     excerpt: "This month, we're exploring how to evaluate AI safety in contexts where compute, data, and infrastructure are limited—exactly where the stakes are highest.",
//     content: `# February 2026 Theme: AI Safety Evaluation

// This month, we're exploring a critical question: How do we evaluate AI safety in contexts where compute, data, and infrastructure are limited—exactly where the stakes are highest?

// ## The Challenge

// Most AI safety tools assume abundant resources: large datasets, powerful GPUs, extensive documentation. But what about:

// - **Small hospitals** using language models to assist with patient care
// - **Government agencies** deploying AI without dedicated tech teams  
// - **NGOs** using models trained on biased Western data
// - **Small businesses** adopting AI tools without understanding their limitations

// ## What We're Building

// Over four weeks, we're developing an open-source framework for bias detection in small language models. Key features:

// - **Lightweight evaluation**: Works on consumer hardware
// - **Context-aware**: Designed for Global South contexts
// - **Interpretable**: Clear explanations, not black boxes
// - **Practical**: Actionable insights for non-technical users

// ## Weekly Structure

// **Week 1**: Foundations of AI evaluation and bias  
// **Week 2**: Case studies of AI failures in constrained contexts  
// **Week 3**: Hands-on development of detection tools  
// **Week 4**: Testing, documentation, and open-source release

// ## Join Us

// - **Discord**: Daily discussions and Q&A
// - **Substack**: Weekly deep dives and readings  
// - **GitHub**: Contribute to the framework

// This is judgment training for a technological era. Let's build it together.`,
//     featured: false,
//   },
//   {
//     id: "welcome-to-unpatterned",
//     title: "Welcome to Unpatterned",
//     subtitle: "Why we're building a practice for cognitive depth",
//     date: "2026-01-15",
//     author: {
//       name: "Founders",
//       role: "Unpatterned",
//     },
//     category: "announcement",
//     excerpt: "The world is moving faster than we can understand it. We're here to slow down, dig deep, and build the cognitive infrastructure for a complex world.",
//     content: `# Welcome to Unpatterned

// The world is moving faster than we can understand it. AI writes. Algorithms decide. Feeds react. We optimize, execute, and move on.

// But something is being lost.

// ## The Quiet Crisis

// We're deploying systems—AI, financial models, digital identity, governance technologies—faster than we're developing the judgment to use them. Speed scales. Depth does not, unless it's built deliberately.

// Unpatterned exists to practice the kind of thinking that preserves institutions, strengthens societies, and prevents fragile innovation.

// ## What We Are

// Not content. Not commentary. Not a credential.

// **A structured practice for building depth.**

// Each month, one theme. Each week, structured challenges. Each cycle, real synthesis. We connect:

// - Mathematics and systems thinking
// - AI and institutions  
// - Design and ethics
// - History and lived constraints

// ## Who This Is For

// People uneasy with superficial answers:

// - Students who want more than exams
// - Engineers who want context beyond code  
// - Founders who value second-order thinking
// - Policymakers who understand restraint
// - Researchers who want synthesis, not silos

// ## What's Required

// Curiosity. Humility. Endurance.

// The emphasis is not on becoming experts—it's on building coherent mental models of how complex systems actually work.

// ## Join Us

// If the world is accelerating, we choose to deepen.

// **Practice thinking.**

// [Join our community](/join) • [Explore themes](#monthly-theme) • [Apply to YES Program](/yes-program)`,
//     featured: false,
//   },
];
